import { KTIcon } from "../../../_metronic/helpers/components/KTIcon"

const PoliticaYPrivacidadSelectorModalHeader = () => {

  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Términos y Condiciones</h2>

      {/* <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div> */}

    </div>
  )
}

export {PoliticaYPrivacidadSelectorModalHeader}
